<template>
  <div>
    <h1 class="display-4">{{ h1 }}</h1>
    <hr />

    <b-form>
      <b-form-group label-for="nom_type">
        <template slot="label">
          Type <span class="text-danger">*</span>
        </template>
        <b-form-input id="nom_type" name="nom_type" placeholder="Nom du type" v-model="name" data-vv-as="Type" v-validate="'required'"></b-form-input>
        <div v-show="errors.has('nom_type')" class="alert alert-danger mt-3">{{ errors.first('nom_type') }}</div>
      </b-form-group>
      <b-form-group label-for="Schools" v-show="id">
        <template slot="label">
          Ecole <span class="text-danger">*</span>
        </template>
        <b-form-select id="Schools" name="Schools" v-model="schoolId" :options="schools" data-vv-as="Ecole" v-validate="{ required: id != undefined }" multiple></b-form-select>
        <div v-show="errors.has('Schools')" class="alert alert-danger mt-3">{{ errors.first('Schools') }}</div>
      </b-form-group>
      <b-btn class="submit" type="submit" variant="primary" @click.prevent="edit">{{ button }}</b-btn>
      <router-link to="/types/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import * as Ladda from 'ladda'

Vue.use(VueResource)

export default {
  data () {
    return {
      button: '',
      h1: '',
      name: '',
      schoolId: [],
      schools: []
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    loop (data, counter, total) {
      if (counter < total) {
        // setTimeout(() => {
        this.$http.post(this.domain + '/api/types/' + this.id + '/school?access_token=' + this.access_token, { id: this.schoolId[counter].id, name: this.schoolId[counter].name }, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            if (response.status === 200 && response.ok) {
              counter++
              this.loop('', counter, total)
              if (counter === total) {
                this.$root.$bvToast.toast('Le type a bien été modifié', {
                  title: 'Type modifié',
                  autoHideDelay: 3000,
                  append: false,
                  variant: 'success'
                })
                this.$router.push('/types/list')
              }
            }
          })
        }, (response) => {

        })
        // }, 1000)
      }
    },
    edit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.id) {
            this.$http.post(this.domain + '/api/types?access_token=' + this.access_token, { name: this.name }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('Le type a bien été ajouté', {
                    title: 'Type ajouté',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/types/list')
                }
              })
            }, (response) => {

            })
          } else {
            let l = Ladda.create(document.querySelector('.submit'))
            l.start()
            this.$http.post(this.domain + '/api/types/' + this.id + '/replace?access_token=' + this.access_token, { name: this.name, schools: [] }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  // Assignation des écoles
                  this.loop('', 0, this.schoolId.length)
                }
              })
            }, (response) => {

            })
          }
        }
      })
    }
  },
  mounted () {
    // document.getElementById('nom_type').focus()
    if (this.id) {
      this.$http.get(this.domain + '/api/types/' + this.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.name = data.name
          for (let i = 0; i < data.schools.length; i++) {
            this.schoolId.push({
              id: data.schools[i].id,
              name: data.schools[i].name
            })
            // console.log(this.schoolId)
          }
          // this.schoolId = data.schoolId
        })
      }, (response) => {

      })
      this.button = 'Editer'
      this.h1 = 'Editer un type'
    } else {
      this.button = 'Valider'
      this.h1 = 'Ajouter un type'
    }

    this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
      response.json().then((data) => {
        for (let i = 0; i < data.length; i++) {
          this.schools.push(
            {
              value: { id: data[i].id, name: data[i].name },
              text: data[i].name
            }
          )
        }
      })
    }, (response) => {

    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Types/Edit.vue